import { Lightbulb, ArrowRight } from "lucide-react";

const BASE = [
  "bons plans Eure-et-Loir",
  "réductions Chartres",
  "commerces locaux",
  "artisans Eure-et-Loir",
  "consommer local",
  "offres partenaires",
  "avantages adhérents",
  "agenda local",
  "pouvoir d'achat",
  "PROXIreduc-28",
];

const NEIGHBORS = {
  "chartres": ["Lucé", "Mainvilliers", "Lèves"],
  "lucé": ["Chartres", "Mainvilliers"],
  "luce": ["Chartres", "Mainvilliers"],
  "mainvilliers": ["Chartres", "Lucé"],
  "lèves": ["Chartres", "Champhol"],
  "leves": ["Chartres", "Champhol"],
  "champhol": ["Chartres", "Lèves"],
  "luisant": ["Chartres", "Lucé"],
  "dreux": ["Vernouillet", "Chérisy", "Luray"],
  "vernouillet": ["Dreux", "Chérisy"],
  "chérisy": ["Dreux", "Vernouillet"],
  "cherisy": ["Dreux", "Vernouillet"],
  "luray": ["Dreux", "Vernouillet"],
  "châteaudun": ["Donnemain-Saint-Mamès", "Saint-Denis-les-Ponts", "Marboué"],
  "chateaudun": ["Donnemain-Saint-Mamès", "Saint-Denis-les-Ponts", "Marboué"],
  "saint-denis-les-ponts": ["Châteaudun", "Jallans"],
  "marboué": ["Châteaudun"],
  "jallans": ["Châteaudun", "Saint-Denis-les-Ponts"],
  "nogent-le-rotrou": ["Margon", "Brunelles", "Trizay-Coutretot-Saint-Serge"],
  "margon": ["Nogent-le-Rotrou"],
  "brunelles": ["Nogent-le-Rotrou"],
};

function tc(s) {
  return (s || "").toLowerCase().replace(/(^|[\s-])([a-zà-ÿ])/g, (m, p, ch) => p + ch.toUpperCase());
}

function themeKeywords(category, city) {
  const c = tc((city || "").trim()) || "Eure-et-Loir";
  const cat = (category || "").toLowerCase();
  const map = [
    [["restaur", "gastro"], [`restaurants ${c}`, `où manger à ${c}`]],
    [["aliment", "terroir", "épicerie", "epicerie"], [`produits locaux ${c}`, `épicerie fine ${c}`]],
    [["beaut", "bien-être", "bien-etre", "coiff", "esth"], [`beauté ${c}`, `coiffeur ${c}`]],
    [["auto", "moto", "garage"], [`garage ${c}`, `entretien auto ${c}`]],
    [["loisir", "culture", "cinéma", "cinema"], [`loisirs ${c}`, `sorties ${c}`]],
    [["sport", "fitness"], [`salle de sport ${c}`, `fitness ${c}`]],
    [["maison", "jardin", "brico", "déco", "deco"], [`maison & jardin ${c}`, `bricolage ${c}`]],
    [["artisan", "service"], [`artisans ${c}`, `services ${c}`]],
    [["professionnel", "entreprise"], [`professionnels ${c}`, `services aux entreprises ${c}`]],
  ];
  for (const [keys, kws] of map) if (keys.some((k) => cat.includes(k))) return kws;
  return [`bons plans ${c}`, `commerces ${c}`];
}

export function buildKeywords(category, city) {
  const theme = themeKeywords(category, city);
  const neigh = (NEIGHBORS[(city || "").toLowerCase().trim()] || [])
    .slice(0, 2)
    .map((n) => `bons plans ${n}`);
  const seen = new Set();
  return [...theme, ...neigh, ...BASE].filter((k) => {
    const low = k.toLowerCase();
    if (seen.has(low)) return false;
    seen.add(low);
    return true;
  });
}

export default function KeywordsSuggestBlock({ category = "", city = "" }) {
  const keywords = buildKeywords(category, city);
  return (
    <div className="mt-6 pt-5 border-t border-slate-100" data-testid="keywords-suggest-block">
      {/* Lien suggestion placé juste après l'article, avant le nuage de mots clés */}
      <a
        href="/suggestions"
        className="inline-flex items-start gap-1.5 text-sm font-semibold text-[#E05638] hover:underline"
        data-testid="keywords-suggest-link"
      >
        <Lightbulb size={15} className="mt-0.5 shrink-0" />
        <span>Aidez-nous à améliorer PROXIreduc-28 ! Une idée pour améliorer PROXIreduc-28 ? Vous connaissez une pépite locale — commerce, professionnel, association, club, comité d'entreprise ? Suggérez-la, c'est gratuit et ça profite à tous !</span>
        <ArrowRight size={14} className="mt-0.5 shrink-0" />
      </a>

      {/* Nuage de mots clés — volontairement très discret */}
      <div className="mt-4 flex flex-wrap items-center gap-1" data-testid="keywords-cloud">
        <span className="text-[9px] uppercase tracking-wider text-slate-300 font-semibold mr-1">Nuage de mots clés</span>
        {keywords.map((k) => (
          <span
            key={k}
            className="text-[9px] leading-tight text-slate-300 bg-slate-50 rounded px-1.5 py-0.5"
            data-testid={`kw-${k.replace(/\s+/g, "-")}`}
          >
            {k}
          </span>
        ))}
      </div>
    </div>
  );
}
